import { jsx, jsxs } from "react/jsx-runtime";
const Edit2 = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsxs("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.793 2.121a3.828 3.828 0 1 1 5.414 5.415l-1 1-9.5 9.5a1 1 0 0 1-.707.292H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10.5-10.5Zm4 4-.293.293-2.586-2.586.293-.292a1.829 1.829 0 0 1 2.586 2.585ZM6 13.743l8.5-8.5 2.586 2.585-8.5 8.5H6v-2.585Z",
                fill: "none",
                className: "tw-fill-current"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M5 20a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z",
                fill: "none",
                className: "tw-fill-current"
            })
        ]
    });
const Edit2_Edit2 = Edit2;
export default Edit2_Edit2;
